/**
 * TrendBuy AI Shopping Assistant — modern, admin-customisable widget
 * Vanilla JS, no dependencies.
 *
 * Theme file:  assets/trendbuy-agent.js
 * Settings:    sections/trendbuy-agent.liquid  (Online Store → Customize → "TrendBuy AI Assistant")
 *
 * Every visual and text setting arrives as JSON in <script id="tb-agent-config">.
 * If that block is missing the widget still works with the defaults below.
 */
(function () {
  "use strict";

  // Loaded twice (the theme editor re-inserts the section)? Just refresh the settings.
  if (window.__tbAgent) { window.__tbAgent.reconfigure(); return; }

  // ─── SETTINGS ────────────────────────────────────────────────────────────
  // Pragya AI default avatar (small embedded image, so it works with no setup). Replace it in the theme editor if you like.
  const DEFAULT_AVATAR = "data:image/webp;base64,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";

  const DEFAULTS = {
    agentUrl: "https://portal.trendbuy.co.in/agent/chat",
    browseUrl: "/collections/trendy-fashion",
    name: "Pragya AI",
    tagline: "",
    welcome: "Hello! I'm Pragya, your TrendBuy shopping assistant. Tell me what you're looking for — a saree for a wedding, a kurta for the office, kids wear, anything! I'll find the perfect match from our live catalog.",
    placeholder: "What are you looking for today?",
    chips: "Sarees for wedding\nKurta under ₹1000\nKids ethnic wear\nCotton sarees\nParty lehenga\nOffice kurti",
    newChatLabel: "New chat",
    showNewChat: true,
    privacyNote: "Chats clear when idle. Anonymous feedback helps us improve.",
    disclaimer: "Pragya AI can make mistakes. Please check important details before you buy.",
    avatarEmoji: "",
    avatarImage: DEFAULT_AVATAR,
    showAvatar: true,
    colors: { c1: "#FF9F1C", c2: "#E4405F", c3: "#FFD166", onGradient: "#FFFFFF" },
    mode: "light",
    angle: 135,
    radius: 24,
    depth: 6,
    glass: true,
    blur: 16,
    font: "theme",
    panelWidth: 380,
    panelHeight: 600,
    position: "right",
    offsetX: 20,
    offsetY: 24,
    launcherStyle: "orb",
    launcherIcon: "sparkle",
    launcherLabel: "Ask Pragya AI",
    launcherSize: 64,
    badge: true,
    pulse: true,
    animation: "lively",
    tilt3d: true,
    autoOpenDelay: 0,
    idleMinutes: 15,
    showBrand: false,
    editorSample: false,
    allowMove: true,
    launcherAvatar: true,
    showFeedback: true,
    shop: { productHandle: "", collectionTitle: "", domain: "" },
  };

  let CFG = JSON.parse(JSON.stringify(DEFAULTS));
  let hadConfigBlock = false;

  function num(v, d) { const n = Number(v); return isFinite(n) ? n : d; }
  function str(v, d) { return typeof v === "string" ? v : d; }
  function bool(v, d) { return typeof v === "boolean" ? v : d; }

  function readConfig() {
    let raw = null;
    const el = document.getElementById("tb-agent-config");
    if (el) { try { raw = JSON.parse(el.textContent); } catch (_) { raw = null; } }
    hadConfigBlock = !!raw;
    const D = DEFAULTS, r = raw || {}, rc = r.colors || {}, rs = r.shop || {};
    const legacy = window.__tb_shopify || {};
    CFG = {
      agentUrl: str(r.agentUrl, "") || D.agentUrl,
      browseUrl: str(r.browseUrl, "") || D.browseUrl,
      name: str(r.name, "") || D.name,
      tagline: str(r.tagline, D.tagline),
      welcome: str(r.welcome, "") || D.welcome,
      placeholder: str(r.placeholder, "") || D.placeholder,
      chips: str(r.chips, D.chips),
      newChatLabel: str(r.newChatLabel, "") || D.newChatLabel,
      showNewChat: bool(r.showNewChat, D.showNewChat),
      privacyNote: str(r.privacyNote, D.privacyNote),
      disclaimer: str(r.disclaimer, D.disclaimer),
      avatarEmoji: str(r.avatarEmoji, D.avatarEmoji),
      avatarImage: str(r.avatarImage, "") || D.avatarImage,
      showAvatar: bool(r.showAvatar, D.showAvatar),
      colors: {
        c1: str(rc.c1, "") || D.colors.c1,
        c2: str(rc.c2, "") || D.colors.c2,
        c3: str(rc.c3, "") || D.colors.c3,
        onGradient: str(rc.onGradient, "") || D.colors.onGradient,
      },
      mode: ["light", "dark", "auto"].indexOf(r.mode) >= 0 ? r.mode : D.mode,
      angle: num(r.angle, D.angle),
      radius: num(r.radius, D.radius),
      depth: Math.max(0, Math.min(10, num(r.depth, D.depth))),
      glass: bool(r.glass, D.glass),
      blur: num(r.blur, D.blur),
      font: ["theme", "system", "rounded", "serif"].indexOf(r.font) >= 0 ? r.font : D.font,
      panelWidth: num(r.panelWidth, D.panelWidth),
      panelHeight: num(r.panelHeight, D.panelHeight),
      position: r.position === "left" ? "left" : "right",
      offsetX: num(r.offsetX, D.offsetX),
      offsetY: num(r.offsetY, D.offsetY),
      launcherStyle: ["orb", "pill", "squircle"].indexOf(r.launcherStyle) >= 0 ? r.launcherStyle : D.launcherStyle,
      launcherIcon: ["sparkle", "chat", "bag", "heart", "star"].indexOf(r.launcherIcon) >= 0 ? r.launcherIcon : D.launcherIcon,
      launcherLabel: str(r.launcherLabel, D.launcherLabel),
      launcherSize: num(r.launcherSize, D.launcherSize),
      badge: bool(r.badge, D.badge),
      pulse: bool(r.pulse, D.pulse),
      animation: ["off", "subtle", "lively"].indexOf(r.animation) >= 0 ? r.animation : D.animation,
      tilt3d: bool(r.tilt3d, D.tilt3d),
      autoOpenDelay: num(r.autoOpenDelay, D.autoOpenDelay),
      idleMinutes: Math.max(1, num(r.idleMinutes, D.idleMinutes)),
      showBrand: bool(r.showBrand, D.showBrand),
      editorSample: bool(r.editorSample, D.editorSample),
      allowMove: bool(r.allowMove, D.allowMove),
      launcherAvatar: bool(r.launcherAvatar, D.launcherAvatar),
      showFeedback: bool(r.showFeedback, D.showFeedback),
      shop: {
        productHandle: str(rs.productHandle, "") || str(legacy.productHandle, ""),
        collectionTitle: str(rs.collectionTitle, "") || str(legacy.collectionTitle, ""),
        domain: str(rs.domain, "") || str(legacy.shopDomain, ""),
      },
    };
  }

  readConfig();

  const DESIGN_MODE = !!(window.Shopify && window.Shopify.designMode);
  const reducedMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  // ─── SESSION (private by design) ─────────────────────────────────────────
  // The session id lives in sessionStorage: it disappears when the tab/browser closes, so the next
  // person on a shared or public computer never inherits a previous chat. A chat idle for
  // `idleMinutes` is cleared automatically (here and on the server).
  const HIST_KEY = "_tb_agent_hist";
  const OPEN_KEY = "_tb_agent_panel";
  const AUTO_KEY = "_tb_agent_auto";
  const MAX_SAVED = 24;
  let sessionId, idleTimer = null, epoch = 0, transcript = [], restoring = false, isSending = false;
  let built = false;

  function idleMs() { return CFG.idleMinutes * 60 * 1000; }
  function eventUrl() { return CFG.agentUrl.replace(/\/chat$/, "/event"); }
  function clearUrl() { return CFG.agentUrl.replace(/\/chat$/, "/session/clear"); }
  function newSid() { return "tb_" + Math.random().toString(36).slice(2) + Date.now().toString(36); }
  const $ = (id) => document.getElementById(id);

  // Anonymous feedback / behaviour signals (thumbs, product clicks, add to cart). Used only to improve answers.
  function sendEvent(kind, turnId, handle, detail) {
    if (DESIGN_MODE || !CFG.showFeedback || !sessionId) return;
    try {
      const body = { session_id: sessionId, kind: kind };
      if (turnId) body.turn_id = turnId;
      if (handle) body.handle = String(handle).slice(0, 120);
      if (detail) body.detail = String(detail).slice(0, 60);
      fetch(eventUrl(), {
        method: "POST", headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body), keepalive: true,
      }).catch(() => {});
    } catch (_) {}
  }

  function clearOnServer(sid) {
    try {
      fetch(clearUrl(), {
        method: "POST", headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ session_id: sid }), keepalive: true,
      }).catch(() => {});
    } catch (_) {}
  }

  (function initSession() {
    try {
      const legacy = localStorage.getItem("_tb_agent_sid");
      if (legacy) { clearOnServer(legacy); localStorage.removeItem("_tb_agent_sid"); }
    } catch (_) {}
    try {
      sessionId = sessionStorage.getItem("_tb_agent_sid");
      const last = parseInt(sessionStorage.getItem("_tb_agent_last") || "0", 10);
      if (sessionId && last && Date.now() - last > idleMs()) {
        clearOnServer(sessionId);
        sessionId = null;
        sessionStorage.removeItem(HIST_KEY);
        sessionStorage.removeItem(OPEN_KEY);
      }
      if (!sessionId) {
        sessionId = newSid();
        sessionStorage.setItem("_tb_agent_sid", sessionId);
      }
    } catch (_) {
      sessionId = newSid();
    }
    try { transcript = JSON.parse(sessionStorage.getItem(HIST_KEY) || "[]"); } catch (_) { transcript = []; }
    if (!Array.isArray(transcript)) transcript = [];
  })();

  function saveTranscript() {
    try {
      if (transcript.length > MAX_SAVED) transcript = transcript.slice(-MAX_SAVED);
      sessionStorage.setItem(HIST_KEY, JSON.stringify(transcript));
    } catch (_) {
      try { transcript = transcript.slice(-6); sessionStorage.setItem(HIST_KEY, JSON.stringify(transcript)); } catch (__) {}
    }
  }

  function armIdle(ms) {
    clearTimeout(idleTimer);
    idleTimer = setTimeout(() => resetChat("idle"), ms);
  }
  function touch() {
    try { sessionStorage.setItem("_tb_agent_last", String(Date.now())); } catch (_) {}
    armIdle(idleMs());
  }

  function resetChat(reason) {
    epoch++;
    clearTimeout(idleTimer);
    clearOnServer(sessionId);
    sessionId = newSid();
    try {
      sessionStorage.setItem("_tb_agent_sid", sessionId);
      sessionStorage.removeItem("_tb_agent_last");
      sessionStorage.removeItem(HIST_KEY);
    } catch (_) {}
    transcript = [];

    const messages = $("tb-messages");
    if (messages) {
      Array.from(messages.children).forEach((el) => { if (el.id !== "tb-typing") el.remove(); });
      hideTyping();
      const note = document.createElement("div");
      note.className = "tb-notice";
      note.textContent = reason === "idle"
        ? "Your chat was cleared after " + CFG.idleMinutes + " minutes of inactivity to protect your privacy."
        : "New chat started. Your previous conversation has been cleared.";
      messages.insertBefore(note, $("tb-typing"));
      const input = $("tb-input");
      if (input) { input.value = ""; input.style.height = "auto"; }
      const send = $("tb-send");
      if (send) send.disabled = true;
      addOpener();
      renderSuggestions();
    }
    isSending = false;
  }

  // ─── INSTANT GREETING HANDLING (no API call) ─────────────────────────────
  const GREETING_RE = /^\s*(hi|hello|hey|namaste|hai|helo|hii|vanakkam|namaskar|good\s+(morning|afternoon|evening|night)|salam|assalamu|greetings|howdy|sup)[!.,?\s]*$/i;
  const GREETING_REPLIES = [
    "Namaste! I'm {name}, your TrendBuy stylist. What are you looking for today — a saree, kurti, lehenga, or something else?",
    "Hello! Welcome to TrendBuy! Tell me what you need — occasion, budget, category — and I'll find the perfect match.",
    "Hi there! Great to have you here. Are you shopping for yourself or as a gift? Let me know and I'll get started!",
    "Good to see you! I'm {name}. Looking for ethnic wear for a special occasion, or just browsing? Tell me more!",
  ];

  // ─── PAGE CONTEXT ────────────────────────────────────────────────────────
  function getPageContext() {
    const ctx = {};
    try {
      if (CFG.shop.productHandle) ctx.page_product_handle = CFG.shop.productHandle;
      else if (window.meta && window.meta.product && window.meta.product.handle) ctx.page_product_handle = window.meta.product.handle;
      if (window.meta && window.meta.selectedVariantId) ctx.page_variant_id = window.meta.selectedVariantId;
      if (CFG.shop.collectionTitle) ctx.page_collection = CFG.shop.collectionTitle;
      else if (document.body.className.includes("template-collection")) {
        const h1 = document.querySelector("h1.collection__title, h1.section-header__title");
        if (h1) ctx.page_collection = h1.textContent.trim();
      }
    } catch (_) {}
    return ctx;
  }

  // ─── ICONS ───────────────────────────────────────────────────────────────
  const ICONS = {
    sparkle: '<path d="M12 2l1.9 5.6L19.5 9.5l-5.6 1.9L12 17l-1.9-5.6L4.5 9.5l5.6-1.9z"/><path d="M19 14l.9 2.6 2.6.9-2.6.9L19 21l-.9-2.6-2.6-.9 2.6-.9z"/><path d="M5 15l.7 1.8 1.8.7-1.8.7L5 20l-.7-1.8-1.8-.7 1.8-.7z"/>',
    chat: '<path d="M4 3h16a2 2 0 012 2v11a2 2 0 01-2 2H10l-5 4v-4H4a2 2 0 01-2-2V5a2 2 0 012-2z"/>',
    bag: '<path d="M5 8h14l-1 13H6L5 8zm4-1V6a3 3 0 016 0v1h-2V6a1 1 0 00-2 0v1H9z"/>',
    heart: '<path d="M12 21s-8-5.2-8-11a4.5 4.5 0 018-2.8A4.5 4.5 0 0120 10c0 5.8-8 11-8 11z"/>',
    star: '<path d="M12 2l3 6.9 7.5.7-5.7 5 1.7 7.4L12 18l-6.5 4 1.7-7.4-5.7-5 7.5-.7z"/>',
  };
  const SVG_OPEN = '<svg viewBox="0 0 24 24" aria-hidden="true" fill="currentColor">';
  const CLOSE_SVG = '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>';
  const SEND_SVG = '<svg viewBox="0 0 24 24" aria-hidden="true" fill="currentColor"><path d="M3.4 11.2L20.6 3.6c.9-.4 1.8.5 1.4 1.4l-7.6 17.2c-.4.9-1.7.8-2-.1l-2.1-7.1-7.1-2.1c-.9-.3-1-1.6-.1-2z"/></svg>';

  // ─── STYLES ──────────────────────────────────────────────────────────────
  const CSS = `
  #tb-agent-root, #tb-agent-root * { box-sizing: border-box; }
  #tb-agent-root {
    --tb-c1:#FF9F1C; --tb-c2:#E4405F; --tb-c3:#FFD166; --tb-on:#fff;
    --tb-angle:135deg; --tb-r:24px; --tb-blur:16px;
    --tb-grad: linear-gradient(var(--tb-angle), var(--tb-c1), var(--tb-c2));
    --tb-fab:64px; --tb-ox:20px; --tb-oy:24px; --tb-l:auto; --tb-r-side:20px;
    --tb-w:380px; --tb-h:600px;
    --tb-shadow: 0 18px 50px rgba(0,0,0,.22);
    --tb-glow: 0 10px 30px rgba(228,64,95,.35);
    --tb-font: inherit;
    font-family: var(--tb-font); font-size: 14px; line-height: 1.5; -webkit-font-smoothing: antialiased;
    color: var(--tb-text);
  }
  #tb-agent-root[data-theme="light"] {
    --tb-bg:#ffffff; --tb-glass:rgba(255,255,255,.80); --tb-text:#1f2937; --tb-muted:#6b7280;
    --tb-line:rgba(17,24,39,.09); --tb-bot:color-mix(in srgb, var(--tb-c1) 9%, #ffffff);
    --tb-input:#f4f5fa; --tb-card:#ffffff; --tb-notice:color-mix(in srgb, var(--tb-c1) 12%, #ffffff);
  }
  #tb-agent-root[data-theme="dark"] {
    --tb-bg:#14161f; --tb-glass:rgba(20,22,31,.80); --tb-text:#eef0f6; --tb-muted:#9aa3b5;
    --tb-line:rgba(255,255,255,.10); --tb-bot:color-mix(in srgb, var(--tb-c1) 20%, #1c1f2e);
    --tb-input:#1c1f2e; --tb-card:#1b1e2b; --tb-notice:color-mix(in srgb, var(--tb-c1) 22%, #14161f);
  }
  #tb-agent-root button { font-family: inherit; }
  #tb-agent-root :focus-visible { outline: 2px solid var(--tb-c3); outline-offset: 2px; }

  /* ── Launcher ───────────────────────────────────────────── */
  #tb-fab-wrap { -webkit-user-select: none; user-select: none; -webkit-touch-callout: none; position: fixed; z-index: 9998; bottom: var(--tb-oy); left: var(--tb-l); right: var(--tb-r-side); touch-action: none; }
  #tb-fab-wrap.dragging #tb-fab { cursor: grabbing; transition: none; animation: none !important; }
  #tb-fab-hide {
    position:absolute; top:-9px; width:22px; height:22px; border-radius:50%; border:0; padding:0; cursor:pointer; z-index:2;
    background: var(--tb-bg); color: var(--tb-text); box-shadow: 0 2px 8px rgba(0,0,0,.3);
    display:flex; align-items:center; justify-content:center; opacity:0; transform:scale(.7); transition: opacity .15s, transform .15s;
  }
  #tb-fab-hide svg { width:11px; height:11px; }
  #tb-agent-root[data-pos="right"] #tb-fab-hide { left:-9px; } #tb-agent-root[data-pos="left"] #tb-fab-hide { right:-9px; }
  #tb-fab-wrap:hover #tb-fab-hide, #tb-fab-hide:focus-visible { opacity:1; transform:none; }
  #tb-agent-root.tb-open #tb-fab-hide { display:none; }
  @media (hover: none) { #tb-fab-hide { opacity:.85; transform:none; } }
  #tb-fab {
    position: relative; cursor: grab;
    height: var(--tb-fab); min-width: var(--tb-fab); padding: 0; border: 0; cursor: pointer;
    display: inline-flex; align-items: center; justify-content: center; gap: 8px;
    color: var(--tb-on); background: var(--tb-grad); border-radius: 50%;
    box-shadow: var(--tb-glow), inset 0 -6px 12px rgba(0,0,0,.18), inset 0 4px 8px rgba(255,255,255,.45);
    transform: perspective(520px) rotateX(var(--tb-rx,0deg)) rotateY(var(--tb-ry,0deg));
    transition: transform .18s ease, box-shadow .25s ease;
  }
  #tb-fab::before {
    content:""; position:absolute; inset:0; border-radius:inherit; pointer-events:none;
    background: radial-gradient(circle at 30% 22%, rgba(255,255,255,.65), rgba(255,255,255,0) 42%);
  }
  #tb-fab:hover { box-shadow: var(--tb-glow), 0 0 0 4px color-mix(in srgb, var(--tb-c3) 40%, transparent), inset 0 -6px 12px rgba(0,0,0,.18), inset 0 4px 8px rgba(255,255,255,.5); }
  #tb-fab:active { transform: perspective(520px) scale(.94); }
  #tb-agent-root[data-launcher="pill"] #tb-fab { border-radius: 999px; padding: 0 22px 0 18px; height: calc(var(--tb-fab) * .84); }
  #tb-agent-root[data-launcher="squircle"] #tb-fab { border-radius: 32%; }
  .tb-fab-ico { position:relative; width: calc(var(--tb-fab) * .46); height: calc(var(--tb-fab) * .46); display:inline-flex; filter: drop-shadow(0 2px 3px rgba(0,0,0,.25)); }
  .tb-fab-ico svg { width:100%; height:100%; }
  #tb-fab[data-face="1"] .tb-fab-main { width: calc(var(--tb-fab) * .84); height: calc(var(--tb-fab) * .84); border-radius:50%; overflow:hidden; border:3px solid rgba(255,255,255,.92); filter:none; box-shadow: 0 3px 10px rgba(0,0,0,.25); }
  #tb-fab[data-face="1"] .tb-fab-main img { width:100%; height:100%; object-fit:cover; display:block; pointer-events:none; }
  .tb-fab-close { display:none; }
  #tb-fab.open .tb-fab-main { display:none; }
  #tb-fab.open .tb-fab-close { display:inline-flex; }
  .tb-fab-label { position:relative; font-weight:700; font-size:14.5px; letter-spacing:.2px; white-space:nowrap; }
  #tb-fab.open .tb-fab-label { display:none; }
  #tb-agent-root[data-launcher="pill"] #tb-fab.open { padding: 0; width: calc(var(--tb-fab) * .84); border-radius:50%; }
  #tb-fab-badge {
    position:absolute; top:-3px; right:-3px; min-width:20px; height:20px; padding:0 5px; border-radius:10px;
    background:#ef4444; color:#fff; font-size:11px; font-weight:800; display:none;
    align-items:center; justify-content:center; border:2px solid var(--tb-bg); box-shadow:0 2px 6px rgba(0,0,0,.3);
  }
  /* pulse rings */
  #tb-agent-root[data-pulse="1"] #tb-fab:not(.open)::after {
    content:""; position:absolute; inset:0; border-radius:inherit; pointer-events:none;
    border: 2px solid var(--tb-c3); opacity:0; animation: tb-ring 2.6s ease-out infinite;
  }
  #tb-agent-root[data-anim="lively"] #tb-fab:not(.open) { animation: tb-float 3.6s ease-in-out infinite; }

  /* ── Panel ──────────────────────────────────────────────── */
  #tb-panel {
    position: fixed; z-index: 9999; left: var(--tb-l); right: var(--tb-r-side);
    bottom: var(--tb-pb, calc(var(--tb-oy) + var(--tb-fab) + 14px));
    width: min(var(--tb-w), calc(100vw - 24px));
    height: min(var(--tb-h), calc(100vh - var(--tb-pb, 100px) - 14px));
    height: min(var(--tb-h), calc(100dvh - var(--tb-pb, 100px) - 14px));
    display: none; flex-direction: column; overflow: hidden;
    border-radius: var(--tb-r); background: var(--tb-bg);
    box-shadow: var(--tb-shadow); border: 1px solid var(--tb-line);
    transform-origin: bottom right; transform: translateY(16px) scale(.94); opacity: 0;
    transition: transform .3s cubic-bezier(.2,.9,.3,1.2), opacity .22s ease;
  }
  #tb-agent-root[data-pos="left"] #tb-panel { transform-origin: bottom left; }
  #tb-panel.visible { display: flex; }
  #tb-panel.shown { transform: none; opacity: 1; }
  #tb-agent-root[data-glass="1"] #tb-panel {
    background: var(--tb-glass);
    -webkit-backdrop-filter: blur(var(--tb-blur)) saturate(170%); backdrop-filter: blur(var(--tb-blur)) saturate(170%);
  }
  /* soft colour glows behind the conversation */
  #tb-panel::before {
    content:""; position:absolute; inset:-20%; pointer-events:none; z-index:0;
    background:
      radial-gradient(circle at 0% 10%, color-mix(in srgb, var(--tb-c1) 22%, transparent), transparent 45%),
      radial-gradient(circle at 100% 95%, color-mix(in srgb, var(--tb-c2) 20%, transparent), transparent 45%);
  }
  #tb-agent-root[data-anim="lively"] #tb-panel::before { animation: tb-drift 14s ease-in-out infinite alternate; }
  #tb-panel > * { position: relative; z-index: 1; }

  /* ── Header ─────────────────────────────────────────────── */
  #tb-header {
    display:flex; align-items:center; gap:11px; padding:15px 14px 14px 16px; flex-shrink:0; overflow:hidden;
    color: var(--tb-on); background: var(--tb-grad);
    box-shadow: 0 6px 18px color-mix(in srgb, var(--tb-c2) 35%, transparent);
  }
  #tb-header::before {
    content:""; position:absolute; inset:0; pointer-events:none;
    background:
      radial-gradient(circle at 12% -20%, color-mix(in srgb, var(--tb-c3) 75%, transparent), transparent 55%),
      radial-gradient(circle at 105% 120%, rgba(255,255,255,.28), transparent 50%);
  }
  #tb-agent-root[data-anim="lively"] #tb-header { background-size: 220% 220%; animation: tb-aurora 9s ease-in-out infinite; }
  #tb-header > * { position: relative; }
  #tb-avatar:empty { display:none; }
  #tb-avatar {
    width:40px; height:40px; border-radius:50%; flex-shrink:0; display:flex; align-items:center; justify-content:center;
    font-size:20px; background: rgba(255,255,255,.26); border: 2px solid rgba(255,255,255,.65);
    box-shadow: 0 4px 12px rgba(0,0,0,.2), inset 0 2px 4px rgba(255,255,255,.5); overflow:hidden; position:relative;
  }
  #tb-avatar img { width:100%; height:100%; object-fit:cover; }
  #tb-header-info { flex:1; min-width:0; }
  #tb-header-name { font-size:17px; font-weight:800; line-height:1.2; text-shadow:0 1px 2px rgba(0,0,0,.2); }
  #tb-header-sub { font-size:11.5px; opacity:.92; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; }
  #tb-new-btn {
    border:1px solid rgba(255,255,255,.4); background: rgba(255,255,255,.18); color: var(--tb-on); cursor:pointer;
    font-size:11.5px; font-weight:700; padding:6px 11px; border-radius:14px; white-space:nowrap;
    -webkit-backdrop-filter: blur(6px); backdrop-filter: blur(6px); transition: background .15s, transform .15s;
  }
  #tb-new-btn:hover { background: rgba(255,255,255,.32); transform: translateY(-1px); }
  #tb-close-btn {
    width:30px; height:30px; border:0; border-radius:50%; cursor:pointer; color: var(--tb-on); background: rgba(255,255,255,.16);
    display:flex; align-items:center; justify-content:center; padding:0; transition: background .15s, transform .2s;
  }
  #tb-close-btn svg { width:15px; height:15px; }
  #tb-close-btn:hover { background: rgba(255,255,255,.32); transform: rotate(90deg); }

  #tb-menu-btn { width:30px; height:30px; border:0; border-radius:50%; cursor:pointer; color: var(--tb-on); background: rgba(255,255,255,.16); display:flex; align-items:center; justify-content:center; padding:0; transition: background .15s; }
  #tb-menu-btn:hover { background: rgba(255,255,255,.32); }
  #tb-menu-btn svg { width:16px; height:16px; }
  #tb-menu {
    position:absolute; z-index:5; top:62px; right:12px; min-width:210px; padding:6px; display:none;
    background: var(--tb-bg); color: var(--tb-text); border:1px solid var(--tb-line); border-radius:14px; box-shadow: 0 14px 34px rgba(0,0,0,.25);
  }
  #tb-menu.show { display:block; }
  #tb-menu button { display:block; width:100%; text-align:left; border:0; background:transparent; color:inherit; font-size:13px; font-weight:600; padding:9px 11px; border-radius:9px; cursor:pointer; }
  #tb-menu button:hover { background: color-mix(in srgb, var(--tb-c1) 14%, transparent); }
  #tb-menu .tb-menu-tip { font-size:11px; color: var(--tb-muted); padding:6px 11px 4px; border-top:1px solid var(--tb-line); margin-top:4px; }

  /* ── Messages ───────────────────────────────────────────── */
  #tb-messages { flex:1; overflow-y:auto; padding:16px 13px 8px; display:flex; flex-direction:column; gap:11px; scroll-behavior:smooth; }
  #tb-messages::-webkit-scrollbar { width:5px; }
  #tb-messages::-webkit-scrollbar-thumb { background: color-mix(in srgb, var(--tb-c1) 40%, transparent); border-radius:5px; }
  .tb-msg { display:flex; flex-direction:column; gap:3px; }
  .tb-msg.user { align-items:flex-end; }
  .tb-msg.bot { align-items:flex-start; }
  .tb-bubble { max-width:84%; padding:10px 14px; font-size:14px; line-height:1.5; border-radius:18px; word-break:break-word; }
  .tb-msg.user .tb-bubble {
    color: var(--tb-on); background: var(--tb-grad); border-bottom-right-radius:5px;
    box-shadow: 0 6px 16px color-mix(in srgb, var(--tb-c2) 32%, transparent), inset 0 1px 0 rgba(255,255,255,.35);
  }
  .tb-msg.bot .tb-bubble {
    color: var(--tb-text); background: var(--tb-bot); border: 1px solid var(--tb-line); border-bottom-left-radius:5px;
    box-shadow: 0 3px 10px rgba(0,0,0,.05);
  }
  .tb-bubble a, .tb-link { color: var(--tb-c2); font-weight:700; text-decoration:underline; text-underline-offset:2px; }
  .tb-time { font-size:10px; color: var(--tb-muted); padding:0 5px; }
  .tb-fb { display:flex; align-items:center; flex-wrap:wrap; gap:4px; padding:0 3px; margin-top:-2px; font-size:11px; color:var(--tb-muted); }
  .tb-fb button { all:unset; box-sizing:border-box; cursor:pointer; display:inline-flex; align-items:center; justify-content:center;
    width:26px; height:26px; border-radius:50%; color:var(--tb-muted); transition:background .15s, color .15s; }
  .tb-fb button:hover, .tb-fb button:focus-visible { background:var(--tb-input); color:var(--tb-c2); }
  .tb-fb button svg { width:15px; height:15px; fill:none; stroke:currentColor; stroke-width:1.8; stroke-linecap:round; stroke-linejoin:round; }
  .tb-fb .tb-fb-chip { width:auto; height:auto; padding:4px 10px; border-radius:999px; font-size:11px; font-weight:600;
    border:1px solid color-mix(in srgb, var(--tb-muted) 40%, transparent); }
  .tb-fb .tb-fb-chip:hover { border-color:var(--tb-c2); }
  .tb-fb-thanks { padding:4px 6px; }
  .tb-notice {
    align-self:center; text-align:center; font-size:11.5px; color: var(--tb-muted); background: var(--tb-notice);
    border-radius:12px; padding:6px 13px; max-width:92%;
  }
  #tb-agent-root[data-anim="lively"] .tb-msg { animation: tb-pop .38s cubic-bezier(.2,.9,.3,1.25) both; }
  #tb-agent-root[data-anim="subtle"] .tb-msg { animation: tb-fade .3s ease both; }

  /* typing */
  #tb-typing { display:none; }
  #tb-typing.show { display:flex; }
  .tb-typing-dots {
    background: var(--tb-bot); border:1px solid var(--tb-line); border-radius:18px; border-bottom-left-radius:5px;
    padding:12px 16px; display:flex; gap:5px; align-items:center;
  }
  .tb-dot { width:7px; height:7px; border-radius:50%; background: var(--tb-grad); animation: tb-wave 1.1s infinite ease-in-out; }
  .tb-dot:nth-child(2){ animation-delay:.15s; } .tb-dot:nth-child(3){ animation-delay:.3s; }

  /* ── Product cards ──────────────────────────────────────── */
  .tb-products { display:flex; flex-direction:column; gap:10px; margin-top:2px; width:100%; }
  .tb-product-card {
    position:relative; display:flex; align-items:stretch; max-width:300px; overflow:hidden;
    border-radius: calc(var(--tb-r) * .6); border: 1.5px solid transparent;
    background: linear-gradient(var(--tb-card), var(--tb-card)) padding-box, var(--tb-grad) border-box;
    box-shadow: 0 8px 22px rgba(0,0,0,.10);
    transform: perspective(700px) rotateX(var(--tb-rx,0deg)) rotateY(var(--tb-ry,0deg));
    transition: transform .15s ease, box-shadow .25s ease;
  }
  .tb-product-card:hover { box-shadow: 0 14px 30px color-mix(in srgb, var(--tb-c2) 28%, transparent); }
  .tb-product-card::after {
    content:""; position:absolute; inset:0; pointer-events:none; opacity:0; transition: opacity .2s;
    background: radial-gradient(circle at var(--tb-mx,50%) var(--tb-my,0%), rgba(255,255,255,.35), transparent 55%);
  }
  .tb-product-card:hover::after { opacity:1; }
  .tb-prod-img { width:88px; flex-shrink:0; object-fit:cover; object-position:top; background: var(--tb-input); }
  .tb-prod-info { flex:1; min-width:0; padding:10px 11px; display:flex; flex-direction:column; justify-content:space-between; gap:6px; }
  .tb-prod-brand { font-size:10px; color: var(--tb-muted); text-transform:uppercase; letter-spacing:.07em; }
  .tb-prod-title { font-size:12.5px; font-weight:700; color: var(--tb-text); line-height:1.3; overflow:hidden; display:-webkit-box; -webkit-line-clamp:2; -webkit-box-orient:vertical; }
  .tb-prod-bottom { display:flex; align-items:center; justify-content:space-between; gap:6px; }
  .tb-prod-price {
    font-size:14.5px; font-weight:800; white-space:nowrap;
    background: var(--tb-grad); -webkit-background-clip:text; background-clip:text; -webkit-text-fill-color:transparent; color: var(--tb-c2);
  }
  .tb-prod-stock { font-size:10px; font-weight:600; }
  .tb-prod-stock.in { color:#10b981; } .tb-prod-stock.out { color:#ef4444; } .tb-prod-stock.low { color:#f59e0b; }
  .tb-prod-actions { display:flex; gap:6px; }
  .tb-btn-view, .tb-btn-cart {
    font-size:11.5px; font-weight:700; border-radius:9px; padding:6px 11px; cursor:pointer; white-space:nowrap; text-decoration:none;
    transition: transform .15s, box-shadow .2s, filter .2s; line-height:1.2;
  }
  .tb-btn-view { color: var(--tb-c2); background: transparent; border:1.5px solid var(--tb-c2); }
  .tb-btn-view:hover { background: color-mix(in srgb, var(--tb-c2) 12%, transparent); transform: translateY(-1px); }
  .tb-btn-cart {
    color: var(--tb-on); background: var(--tb-grad); border:1.5px solid transparent;
    box-shadow: 0 4px 10px color-mix(in srgb, var(--tb-c2) 32%, transparent), inset 0 1px 0 rgba(255,255,255,.35);
  }
  .tb-btn-cart:hover { transform: translateY(-1px); filter: brightness(1.06); }
  .tb-btn-cart:disabled { background:#9ca3af; box-shadow:none; cursor:default; transform:none; filter:none; }

  /* ── Suggestions ────────────────────────────────────────── */
  #tb-suggestions { display:flex; flex-wrap:nowrap; gap:7px; overflow-x:auto; padding:2px 13px 10px; flex-shrink:0; scrollbar-width:none; }
  #tb-suggestions:empty { display:none; }
  #tb-suggestions::-webkit-scrollbar { display:none; }
  .tb-chip {
    flex-shrink:0; white-space:nowrap; cursor:pointer; font-size:12.5px; font-weight:600; color: var(--tb-text);
    padding:6px 13px; border-radius:20px; border:1.5px solid transparent;
    background: linear-gradient(var(--tb-card), var(--tb-card)) padding-box, var(--tb-grad) border-box;
    transition: transform .15s, box-shadow .2s, color .2s;
  }
  .tb-chip:hover { transform: translateY(-2px); color: var(--tb-on); background: var(--tb-grad); box-shadow: 0 6px 14px color-mix(in srgb, var(--tb-c2) 35%, transparent); }

  /* ── Input ──────────────────────────────────────────────── */
  #tb-input-area { flex-shrink:0; display:flex; gap:9px; align-items:flex-end; padding:11px 13px 6px; border-top:1px solid var(--tb-line); background: color-mix(in srgb, var(--tb-bg) 70%, transparent); }
  #tb-input {
    flex:1; font:inherit; font-size:14px; line-height:1.4; color: var(--tb-text); background: var(--tb-input);
    border:1.5px solid transparent; border-radius:16px; padding:10px 14px; resize:none; outline:none;
    max-height:92px; min-height:40px; transition: border-color .2s, box-shadow .2s, background .2s;
  }
  #tb-input::placeholder { color: var(--tb-muted); }
  #tb-input:focus { border-color: var(--tb-c1); background: var(--tb-bg); box-shadow: 0 0 0 4px color-mix(in srgb, var(--tb-c1) 22%, transparent); }
  #tb-send {
    position:relative; width:42px; height:42px; flex-shrink:0; border:0; border-radius:50%; cursor:pointer; padding:0;
    color: var(--tb-on); background: var(--tb-grad); display:flex; align-items:center; justify-content:center;
    box-shadow: 0 6px 14px color-mix(in srgb, var(--tb-c2) 40%, transparent), inset 0 -3px 6px rgba(0,0,0,.15), inset 0 2px 4px rgba(255,255,255,.4);
    transition: transform .15s, box-shadow .2s, opacity .2s;
  }
  #tb-send svg { width:19px; height:19px; margin-left:2px; }
  #tb-send:hover:not(:disabled) { transform: translateY(-2px) scale(1.06); }
  #tb-send:active:not(:disabled) { transform: scale(.92); }
  #tb-send:disabled { background: color-mix(in srgb, var(--tb-muted) 45%, transparent); box-shadow:none; cursor:default; }
  #tb-privacy { flex-shrink:0; text-align:center; font-size:10.5px; color: var(--tb-muted); padding:0 12px 9px; background: color-mix(in srgb, var(--tb-bg) 70%, transparent); }
  #tb-privacy:empty { display:none; }

  /* ── Mobile: bottom sheet ───────────────────────────────── */
  @media (max-width: 520px) {
    #tb-panel {
      left:0; right:0; bottom:0; width:100%; height:min(var(--tb-h), 86vh); height:min(var(--tb-h), 86dvh);
      border-radius: var(--tb-r) var(--tb-r) 0 0; transform-origin: bottom center; transform: translateY(40px); border-width:1px 0 0;
    }
    #tb-agent-root.tb-open #tb-fab-wrap { display:none; }
    #tb-panel { bottom:0 !important; }
  }

  /* ── Animations ─────────────────────────────────────────── */
  @keyframes tb-aurora { 0%{background-position:0% 40%} 50%{background-position:100% 60%} 100%{background-position:0% 40%} }
  @keyframes tb-drift { 0%{transform:translate(0,0) scale(1)} 100%{transform:translate(-4%,3%) scale(1.08)} }
  @keyframes tb-float { 0%,100%{translate:0 0} 50%{translate:0 -5px} }
  @keyframes tb-ring { 0%{transform:scale(1);opacity:.7} 100%{transform:scale(1.65);opacity:0} }
  @keyframes tb-pop { 0%{opacity:0;transform:translateY(10px) scale(.94)} 100%{opacity:1;transform:none} }
  @keyframes tb-fade { from{opacity:0} to{opacity:1} }
  @keyframes tb-wave { 0%,60%,100%{transform:translateY(0);opacity:.5} 30%{transform:translateY(-6px);opacity:1} }

  #tb-agent-root[data-anim="off"] *, #tb-agent-root[data-anim="off"] *::before, #tb-agent-root[data-anim="off"] *::after { animation: none !important; }
  #tb-agent-root[data-anim="off"] #tb-fab::after { display:none; }
  #tb-agent-root[data-anim="off"] .tb-dot { animation: tb-wave 1.1s infinite ease-in-out !important; }
  @media (prefers-reduced-motion: reduce) {
    #tb-agent-root *, #tb-agent-root *::before, #tb-agent-root *::after { animation: none !important; transition: none !important; }
    #tb-agent-root .tb-dot { animation: none !important; }
  }
  `;

  // ─── APPLY SETTINGS ──────────────────────────────────────────────────────
  const FONTS = {
    theme: "inherit",
    system: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
    rounded: "ui-rounded, 'SF Pro Rounded', 'Nunito', 'Quicksand', 'Segoe UI', system-ui, sans-serif",
    serif: "Georgia, 'Times New Roman', serif",
  };

  function hexToRgb(hex) {
    const m = /^#?([0-9a-f]{3}|[0-9a-f]{6})$/i.exec(String(hex).trim());
    if (!m) return [228, 64, 95];
    let h = m[1];
    if (h.length === 3) h = h.split("").map((c) => c + c).join("");
    return [parseInt(h.slice(0, 2), 16), parseInt(h.slice(2, 4), 16), parseInt(h.slice(4, 6), 16)];
  }

  let mqDark = null;
  function resolvedTheme() {
    if (CFG.mode === "auto") return window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
    return CFG.mode;
  }

  // Where the button sits: the admin's setting, unless the visitor moved it (saved in this browser).
  let userPos = null;
  try { userPos = JSON.parse(localStorage.getItem("_tb_agent_pos") || "null"); } catch (_) {}
  if (DESIGN_MODE || !userPos || (userPos.side !== "left" && userPos.side !== "right") || !isFinite(userPos.ox) || !isFinite(userPos.oy)) userPos = null;

  function curPos() {
    if (userPos && CFG.allowMove) return userPos;
    return { side: CFG.position, ox: CFG.offsetX, oy: CFG.offsetY };
  }
  function applyPosition() {
    const root = $("tb-agent-root"); if (!root) return;
    const p = curPos(), s = root.style;
    s.setProperty("--tb-ox", p.ox + "px");
    s.setProperty("--tb-oy", p.oy + "px");
    if (p.side === "left") { s.setProperty("--tb-l", p.ox + "px"); s.setProperty("--tb-r-side", "auto"); }
    else { s.setProperty("--tb-l", "auto"); s.setProperty("--tb-r-side", p.ox + "px"); }
    root.setAttribute("data-pos", p.side);
    // keep the chat window on screen even if the button was dragged near the top
    const vh = window.innerHeight || 800;
    const want = p.oy + CFG.launcherSize + 14;
    const maxPb = Math.max(14, vh - Math.min(CFG.panelHeight, vh - 40) - 14);
    s.setProperty("--tb-pb", Math.min(want, maxPb) + "px");
  }
  function savePos() { if (DESIGN_MODE) return; try { localStorage.setItem("_tb_agent_pos", JSON.stringify(userPos)); } catch (_) {} }

  function applyConfig() {
    const root = $("tb-agent-root");
    if (!root) return;
    const s = root.style, d = CFG.depth, c = CFG.colors;
    const rgb2 = hexToRgb(c.c2).join(",");

    s.setProperty("--tb-c1", c.c1);
    s.setProperty("--tb-c2", c.c2);
    s.setProperty("--tb-c3", c.c3);
    s.setProperty("--tb-on", c.onGradient);
    s.setProperty("--tb-angle", CFG.angle + "deg");
    s.setProperty("--tb-r", CFG.radius + "px");
    s.setProperty("--tb-blur", CFG.blur + "px");
    s.setProperty("--tb-fab", CFG.launcherSize + "px");
    s.setProperty("--tb-w", CFG.panelWidth + "px");
    s.setProperty("--tb-h", CFG.panelHeight + "px");
    applyPosition();
    s.setProperty("--tb-font", FONTS[CFG.font] || FONTS.theme);
    // depth 0 = flat … 10 = deep floating shadows
    s.setProperty("--tb-shadow", d === 0 ? "0 0 0 1px rgba(0,0,0,.06)"
      : "0 " + (d * 3) + "px " + (d * 9) + "px rgba(0,0,0," + (0.08 + d * 0.022).toFixed(3) + "), 0 " + d + "px " + (d * 3) + "px rgba(0,0,0,.10)");
    s.setProperty("--tb-glow", d === 0 ? "0 0 0 rgba(0,0,0,0)"
      : "0 " + (d * 1.4).toFixed(1) + "px " + (d * 4) + "px rgba(" + rgb2 + "," + (0.18 + d * 0.035).toFixed(3) + ")");

    root.setAttribute("data-theme", resolvedTheme());
    root.setAttribute("data-anim", CFG.animation);
    root.setAttribute("data-glass", CFG.glass ? "1" : "0");
    root.setAttribute("data-launcher", CFG.launcherStyle);
    root.setAttribute("data-pulse", CFG.pulse ? "1" : "0");
    root.setAttribute("data-tilt", CFG.tilt3d ? "1" : "0");

    // texts
    const av = $("tb-avatar");
    if (av) {
      av.textContent = "";
      if (CFG.showAvatar && CFG.avatarImage) {
        const img = document.createElement("img");
        img.src = CFG.avatarImage; img.alt = "";
        av.appendChild(img);
      } else {
        if (CFG.avatarEmoji) av.appendChild(document.createTextNode(CFG.avatarEmoji));
      }
    }
    $("tb-header-name").textContent = CFG.name;
    const sub = $("tb-header-sub");
    sub.textContent = CFG.tagline; sub.style.display = CFG.tagline ? "" : "none";
    $("tb-panel").setAttribute("aria-label", CFG.name);
    $("tb-input").setAttribute("placeholder", CFG.placeholder);
    const nb = $("tb-new-btn");
    nb.innerHTML = '<svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" style="vertical-align:-1px;margin-right:5px"><path d="M20 11a8 8 0 10-2.3 5.7"/><path d="M20 4v7h-7"/></svg>'; nb.appendChild(document.createTextNode(CFG.newChatLabel)); nb.style.display = CFG.showNewChat ? "" : "none";
    const pv = $("tb-privacy"); pv.textContent = "";
    [CFG.disclaimer, CFG.privacyNote].forEach((t) => { if (t) { const d = document.createElement("div"); d.textContent = t; pv.appendChild(d); } });
    $("tb-menu-btn").style.display = CFG.allowMove ? "" : "none";
    $("tb-fab-hide").style.display = CFG.allowMove ? "" : "none";
    $("tb-mv-side").textContent = curPos().side === "right" ? "Move to the left corner" : "Move to the right corner";

    // launcher
    const fab = $("tb-fab");
    fab.setAttribute("aria-label", "Open " + CFG.name + " assistant");
    fab.setAttribute("title", "Ask " + CFG.name + (CFG.allowMove ? " — drag to move" : ""));
    const fm = fab.querySelector(".tb-fab-main");
    if (CFG.launcherAvatar && CFG.showAvatar && CFG.avatarImage) {
      fm.textContent = "";
      const im = document.createElement("img");
      im.src = CFG.avatarImage; im.alt = ""; im.draggable = false;
      fm.appendChild(im); fab.setAttribute("data-face", "1");
    } else {
      fm.innerHTML = SVG_OPEN + ICONS[CFG.launcherIcon] + "</svg>"; fab.removeAttribute("data-face");
    }
    const lab = fab.querySelector(".tb-fab-label");
    lab.textContent = CFG.launcherLabel;
    lab.style.display = CFG.launcherStyle === "pill" && CFG.launcherLabel ? "" : "none";

    // theme-follow-device listener
    if (window.matchMedia) {
      if (!mqDark) {
        mqDark = window.matchMedia("(prefers-color-scheme: dark)");
        const h = () => { if (CFG.mode === "auto") $("tb-agent-root").setAttribute("data-theme", resolvedTheme()); };
        if (mqDark.addEventListener) mqDark.addEventListener("change", h); else if (mqDark.addListener) mqDark.addListener(h);
      }
    }
  }

  // ─── BUILD DOM ───────────────────────────────────────────────────────────
  function init() {
    if (built) return;
    built = true;

    if (!document.getElementById("tb-agent-style")) {
      const styleEl = document.createElement("style");
      styleEl.id = "tb-agent-style";
      styleEl.textContent = CSS;
      document.head.appendChild(styleEl);
    }

    const root = document.createElement("div");
    root.id = "tb-agent-root";
    // In the theme editor the widget lives INSIDE its section, so clicking it opens this section's settings.
    const cfgEl = document.getElementById("tb-agent-config");
    const host = DESIGN_MODE && cfgEl && cfgEl.closest ? cfgEl.closest(".shopify-section") : null;
    (host || document.body).appendChild(root);

    root.innerHTML = `
      <div id="tb-fab-wrap">
        <button id="tb-fab" type="button" aria-label="Open assistant">
          <span class="tb-fab-ico tb-fab-main"></span>
          <span class="tb-fab-ico tb-fab-close">${CLOSE_SVG}</span>
          <span class="tb-fab-label"></span>
          <span id="tb-fab-badge">1</span>
        </button>
        <button id="tb-fab-hide" type="button" aria-label="Hide assistant for today" title="Hide for today">${CLOSE_SVG}</button>
      </div>

      <div id="tb-panel" role="dialog" aria-label="Assistant">
        <div id="tb-header">
          <div id="tb-avatar"></div>
          <div id="tb-header-info">
            <div id="tb-header-name"></div>
            <div id="tb-header-sub"></div>
          </div>
          <button id="tb-new-btn" type="button" aria-label="Start a new chat and clear this conversation" title="Clear this chat and start a new one"></button>
          <button id="tb-menu-btn" type="button" aria-label="More options" title="More options"><svg viewBox="0 0 24 24" fill="currentColor"><circle cx="5" cy="12" r="2"/><circle cx="12" cy="12" r="2"/><circle cx="19" cy="12" r="2"/></svg></button>
          <button id="tb-close-btn" type="button" aria-label="Close chat">${CLOSE_SVG}</button>
        </div>
        <div id="tb-menu" role="menu">
          <button type="button" id="tb-mv-side" role="menuitem"></button>
          <button type="button" id="tb-mv-reset" role="menuitem">Reset button position</button>
          <button type="button" id="tb-hide-day" role="menuitem">Hide assistant for today</button>
          <div class="tb-menu-tip">Tip: drag the round button anywhere on the screen.</div>
        </div>

        <div id="tb-messages" role="log" aria-live="polite" aria-atomic="false">
          <div id="tb-typing" aria-hidden="true">
            <div class="tb-typing-dots"><div class="tb-dot"></div><div class="tb-dot"></div><div class="tb-dot"></div></div>
          </div>
        </div>

        <div id="tb-suggestions"></div>

        <div id="tb-input-area">
          <textarea id="tb-input" rows="1" aria-label="Message" autocomplete="off"></textarea>
          <button id="tb-send" type="button" aria-label="Send" disabled>${SEND_SVG}</button>
        </div>
        <div id="tb-privacy"></div>
      </div>
    `;

    applyConfig();
    bindEvents();
    bindTilt(root);

    if (!DESIGN_MODE) {
      try {
        if (parseInt(localStorage.getItem("_tb_agent_hidden") || "0", 10) > Date.now()) root.style.display = "none";
      } catch (_) {}
    }
    bindMove();
    if (DESIGN_MODE && CFG.editorSample) {
      renderSample();           // the chat window stays closed until the ball is clicked
    } else {
      if (transcript.length) {
        restoring = true;
        transcript.forEach((m) => appendMessage(m.role, m.html, m.products || [], m.time));
        restoring = false;
        const last = parseInt(sessionStorage.getItem("_tb_agent_last") || "0", 10);
        armIdle(last ? Math.max(1000, idleMs() - (Date.now() - last)) : idleMs());
      } else {
        renderSuggestions();
        setTimeout(addOpener, 400);
      }
      try { if (sessionStorage.getItem(OPEN_KEY) === "1") openPanel(true); } catch (_) {}
      scheduleBadgeAndAutoOpen();
    }
  }

  function scheduleBadgeAndAutoOpen() {
    try {
      if (CFG.badge && !localStorage.getItem("_tb_agent_opened")) {
        setTimeout(() => { const b = $("tb-fab-badge"); if (b && !$("tb-panel").classList.contains("visible")) b.style.display = "flex"; }, 3000);
      }
    } catch (_) {}
    try {
      if (CFG.autoOpenDelay > 0 && !sessionStorage.getItem(AUTO_KEY) && sessionStorage.getItem(OPEN_KEY) !== "1") {
        setTimeout(() => {
          try { sessionStorage.setItem(AUTO_KEY, "1"); } catch (_) {}
          if (!$("tb-panel").classList.contains("visible")) openPanel();
        }, CFG.autoOpenDelay * 1000);
      }
    } catch (_) {}
  }

  // ─── 3D TILT ─────────────────────────────────────────────────────────────
  function bindTilt(root) {
    function tilt(el, e, max) {
      const r = el.getBoundingClientRect();
      const x = (e.clientX - r.left) / r.width, y = (e.clientY - r.top) / r.height;
      el.style.setProperty("--tb-ry", ((x - 0.5) * 2 * max).toFixed(2) + "deg");
      el.style.setProperty("--tb-rx", ((0.5 - y) * 2 * max).toFixed(2) + "deg");
      el.style.setProperty("--tb-mx", (x * 100).toFixed(0) + "%");
      el.style.setProperty("--tb-my", (y * 100).toFixed(0) + "%");
    }
    function reset(el) {
      el.style.removeProperty("--tb-ry"); el.style.removeProperty("--tb-rx");
      el.style.removeProperty("--tb-mx"); el.style.removeProperty("--tb-my");
    }
    root.addEventListener("pointermove", (e) => {
      if (!CFG.tilt3d || reducedMotion || CFG.animation === "off" || e.pointerType !== "mouse") return;
      const el = e.target.closest && e.target.closest(".tb-product-card, #tb-fab");
      if (el) tilt(el, e, el.id === "tb-fab" ? 16 : 7);
    });
    root.addEventListener("pointerout", (e) => {
      const el = e.target.closest && e.target.closest(".tb-product-card, #tb-fab");
      if (el && !(e.relatedTarget && el.contains(e.relatedTarget))) reset(el);
    });
  }

  // ─── EVENTS ──────────────────────────────────────────────────────────────
  function bindEvents() {
    const input = $("tb-input"), send = $("tb-send");
    $("tb-fab").addEventListener("click", togglePanel);
    $("tb-close-btn").addEventListener("click", closePanel);
    $("tb-new-btn").addEventListener("click", () => resetChat("manual"));
    input.addEventListener("input", () => {
      touch();
      send.disabled = !input.value.trim();
      input.style.height = "auto";
      input.style.height = Math.min(input.scrollHeight, 92) + "px";
    });
    input.addEventListener("keydown", (e) => {
      if (e.key === "Enter" && !e.shiftKey) { e.preventDefault(); sendMessage(); }
    });
    send.addEventListener("click", sendMessage);
  }

  // ─── MOVE / HIDE (visitor controls) ──────────────────────────────────────
  function closeMenu() { const m = $("tb-menu"); if (m) m.classList.remove("show"); }
  function hideForToday() {
    closePanel();
    try { localStorage.setItem("_tb_agent_hidden", String(Date.now() + 24 * 3600 * 1000)); } catch (_) {}
    $("tb-agent-root").style.display = "none";
  }
  let justDragged = false;
  function bindMove() {
    const wrap = $("tb-fab-wrap"), fab = $("tb-fab");
    $("tb-fab-hide").addEventListener("click", (e) => { e.stopPropagation(); hideForToday(); });
    $("tb-menu-btn").addEventListener("click", (e) => { e.stopPropagation(); $("tb-menu").classList.toggle("show"); });
    document.addEventListener("click", (e) => { if (!e.target.closest || !e.target.closest("#tb-menu, #tb-menu-btn")) closeMenu(); });
    $("tb-hide-day").addEventListener("click", () => { closeMenu(); hideForToday(); });
    $("tb-mv-side").addEventListener("click", () => {
      const p = curPos();
      userPos = { side: p.side === "right" ? "left" : "right", ox: p.ox, oy: p.oy };
      savePos(); applyPosition(); applyConfig(); closeMenu();
    });
    $("tb-mv-reset").addEventListener("click", () => {
      userPos = null; try { localStorage.removeItem("_tb_agent_pos"); } catch (_) {}
      applyPosition(); applyConfig(); closeMenu();
    });

    let st = null, moved = false;
    fab.addEventListener("pointerdown", (e) => {
      if (!CFG.allowMove || (e.button && e.button > 0)) return;
      st = { x: e.clientX, y: e.clientY, r: wrap.getBoundingClientRect() }; moved = false;
      try { fab.setPointerCapture(e.pointerId); } catch (_) {}
    });
    window.addEventListener("pointermove", (e) => {
      if (!st) return;
      const dx = e.clientX - st.x, dy = e.clientY - st.y;
      if (!moved && Math.hypot(dx, dy) < 6) return;
      moved = true; wrap.classList.add("dragging");
      const vw = window.innerWidth, vh = window.innerHeight, w = st.r.width, h = st.r.height;
      const left = Math.min(Math.max(4, st.r.left + dx), vw - w - 4);
      const top = Math.min(Math.max(4, st.r.top + dy), vh - h - 4);
      const side = left + w / 2 < vw / 2 ? "left" : "right";
      userPos = { side: side, ox: Math.round(side === "left" ? left : vw - (left + w)), oy: Math.round(vh - (top + h)) };
      applyPosition();
    });
    const endDrag = () => {
      if (st && moved) { savePos(); justDragged = true; setTimeout(() => { justDragged = false; }, 60); applyConfig(); }
      wrap.classList.remove("dragging"); st = null;
    };
    window.addEventListener("pointerup", endDrag);
    window.addEventListener("pointercancel", endDrag);
    window.addEventListener("resize", applyPosition);
  }

  function togglePanel() {
    if (justDragged) return;
    if ($("tb-panel").classList.contains("visible")) closePanel(); else openPanel();
  }

  function openPanel(fromRestore) {
    const panel = $("tb-panel");
    $("tb-fab").classList.add("open");
    $("tb-agent-root").classList.add("tb-open");
    panel.classList.add("visible");
    panel.style.display = "flex";
    setTimeout(() => panel.classList.add("shown"), 10);
    $("tb-fab-badge").style.display = "none";
    if (fromRestore !== true) $("tb-input").focus();
    try { localStorage.setItem("_tb_agent_opened", "1"); } catch (_) {}
    if (!DESIGN_MODE) { try { sessionStorage.setItem(OPEN_KEY, "1"); } catch (_) {} }
    if (fromRestore !== true) touch();
    scrollToBottom();
  }

  function closePanel() {
    if (!DESIGN_MODE) { try { sessionStorage.setItem(OPEN_KEY, "0"); } catch (_) {} }
    const panel = $("tb-panel");
    $("tb-fab").classList.remove("open");
    $("tb-agent-root").classList.remove("tb-open");
    panel.classList.remove("shown");
    setTimeout(() => { if (!panel.classList.contains("shown")) { panel.classList.remove("visible"); panel.style.display = ""; } }, 240);
  }

  // ─── QUICK-REPLY CHIPS ───────────────────────────────────────────────────
  function renderSuggestions() {
    const container = $("tb-suggestions");
    if (!container) return;
    container.innerHTML = "";
    CFG.chips.split(/\r?\n/).map((t) => t.trim()).filter(Boolean).slice(0, 10).forEach((text) => {
      const chip = document.createElement("button");
      chip.type = "button";
      chip.className = "tb-chip";
      chip.textContent = text;
      chip.addEventListener("click", () => {
        $("tb-input").value = text;
        container.innerHTML = "";
        sendMessage();
      });
      container.appendChild(chip);
    });
  }

  // ─── MESSAGING ───────────────────────────────────────────────────────────
  async function sendMessage() {
    if (isSending) return;
    const input = $("tb-input"), send = $("tb-send");
    const msg = input.value.trim();
    if (!msg) return;

    isSending = true;
    touch();
    input.value = "";
    input.style.height = "auto";
    send.disabled = true;
    $("tb-suggestions").innerHTML = "";
    addUserMessage(msg);

    if (DESIGN_MODE && CFG.editorSample) {      // theme editor: never call the live server
      showTyping();
      await new Promise((r) => setTimeout(r, 900));
      hideTyping();
      addBotMessage("This is a preview in the theme editor — real answers appear on your live store.", []);
      isSending = false;
      return;
    }

    if (GREETING_RE.test(msg)) {
      showTyping();
      await new Promise((r) => setTimeout(r, 650));
      hideTyping();
      addBotMessage(GREETING_REPLIES[Math.floor(Math.random() * GREETING_REPLIES.length)].replace("{name}", CFG.name), []);
      isSending = false;
      touch();
      return;
    }

    showTyping();
    const success = await callAgent(msg);
    if (!success) {
      await new Promise((r) => setTimeout(r, 800));
      const retried = await callAgent(msg);
      if (!retried) {
        hideTyping();
        addBotMessageHtml(
          "Sorry, something went wrong on my end. Please try again in a moment, or " +
          '<a class="tb-link" href="' + escapeAttr(CFG.browseUrl) + '" target="_top">browse our collection directly</a>.',
          []
        );
      }
    }
    isSending = false;
    touch();
  }

  async function callAgent(msg) {
    const myEpoch = epoch;
    try {
      const res = await fetch(CFG.agentUrl, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(Object.assign({ message: msg, session_id: sessionId }, getPageContext())),
      });
      if (!res.ok) return false;
      const data = await res.json();
      if (myEpoch !== epoch) return true;
      if (!data.reply && !(data.products && data.products.length)) return true;
      hideTyping();
      addBotMessage(data.reply || "", data.products || [], data.turn_id);
      return true;
    } catch (_) {
      return false;
    }
  }

  function addUserMessage(text) { appendMessage("user", escapeHtml(text), []); }
  function addBotMessage(text, products, turnId) { appendMessage("bot", formatBotText(text), products, undefined, turnId); }
  function addOpener() { addBotMessage(CFG.welcome, []); }
  function addBotMessageHtml(html, products) { appendMessage("bot", html, products); }

  function appendMessage(role, html, products, savedTime, turnId) {
    const messages = $("tb-messages"), typing = $("tb-typing");
    const wrapper = document.createElement("div");
    wrapper.className = "tb-msg " + role;

    if (html) {
      const bubble = document.createElement("div");
      bubble.className = "tb-bubble";
      bubble.innerHTML = html;
      wrapper.appendChild(bubble);
    }
    const time = document.createElement("div");
    time.className = "tb-time";
    const when = savedTime || new Date().toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
    time.textContent = when;
    wrapper.appendChild(time);
    messages.insertBefore(wrapper, typing);

    if (products && products.length) messages.insertBefore(buildProductCards(products, turnId), typing);
    if (role === "bot" && turnId && html && !restoring && CFG.showFeedback && !DESIGN_MODE) messages.insertBefore(buildFeedback(turnId), typing);
    scrollToBottom();

    if (!restoring) {
      transcript.push({ role: role, html: html, products: products || [], time: when });
      saveTranscript();
    }
  }

  function showTyping() { $("tb-typing").classList.add("show"); scrollToBottom(); }
  function hideTyping() { const t = $("tb-typing"); if (t) t.classList.remove("show"); }
  function scrollToBottom() { const m = $("tb-messages"); if (m) m.scrollTop = m.scrollHeight; }

  // ─── PRODUCT CARDS ───────────────────────────────────────────────────────
  function buildFeedback(turnId) {
    const row = document.createElement("div");
    row.className = "tb-fb tb-msg bot";
    const up = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M7 11v9H4v-9h3zM7 11l4-8a2 2 0 0 1 2 2v4h6a2 2 0 0 1 2 2.3l-1.2 6A2 2 0 0 1 17.8 20H7"/></svg>';
    const down = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M17 13V4h3v9h-3zM17 13l-4 8a2 2 0 0 1-2-2v-4H5a2 2 0 0 1-2-2.3l1.2-6A2 2 0 0 1 6.2 4H17"/></svg>';
    function done(text) { row.innerHTML = ""; const t = document.createElement("span"); t.className = "tb-fb-thanks"; t.textContent = text; row.appendChild(t); }
    function mk(label, html, fn) {
      const b = document.createElement("button");
      b.type = "button"; b.setAttribute("aria-label", label); b.title = label; b.innerHTML = html; b.addEventListener("click", fn);
      return b;
    }
    row.appendChild(mk("Helpful", up, function () { sendEvent("thumb_up", turnId); done("Thanks for the feedback."); }));
    row.appendChild(mk("Not helpful", down, function () {
      sendEvent("thumb_down", turnId);
      row.innerHTML = "";
      const q = document.createElement("span"); q.className = "tb-fb-thanks"; q.textContent = "What went wrong?";
      row.appendChild(q);
      [["Wrong products", "wrong_products"], ["Did not understand", "misunderstood"], ["Other", "other"]].forEach(function (r) {
        const c = document.createElement("button"); c.type = "button"; c.className = "tb-fb-chip"; c.textContent = r[0];
        c.addEventListener("click", function () { sendEvent("thumb_down", turnId, "", r[1]); done("Thanks, this helps us improve."); });
        row.appendChild(c);
      });
    }));
    return row;
  }

  function buildProductCards(products, turnId) {
    const container = document.createElement("div");
    container.className = "tb-products tb-msg bot";

    products.forEach((p) => {
      const card = document.createElement("div");
      card.className = "tb-product-card";

      const priceStr = p.min_price === p.max_price
        ? "₹" + p.min_price.toLocaleString("en-IN")
        : "₹" + p.min_price.toLocaleString("en-IN") + "–₹" + p.max_price.toLocaleString("en-IN");
      const stockClass = !p.in_stock ? "out" : p.low_stock ? "low" : "in";
      const stockLabel = !p.in_stock ? "Out of stock" : p.low_stock ? "Only a few left" : "In stock";

      const firstVariant = (p.variants || []).find((v) => v.available);
      const numericVariantId = firstVariant ? String(firstVariant.id).replace("gid://shopify/ProductVariant/", "") : null;
      const brand = CFG.showBrand && p.brand ? `<div class="tb-prod-brand">${escapeHtml(p.brand)}</div>` : "";

      card.innerHTML = `
        ${p.image_url
          ? `<img class="tb-prod-img" src="${escapeAttr(p.image_url)}" alt="${escapeAttr(p.title)}" loading="lazy">`
          : `<div class="tb-prod-img" style="min-height:88px"></div>`}
        <div class="tb-prod-info">
          <div>
            ${brand}
            <div class="tb-prod-title">${escapeHtml(p.title)}</div>
          </div>
          <div class="tb-prod-bottom">
            <span class="tb-prod-price">${priceStr}</span>
            <span class="tb-prod-stock ${stockClass}">${stockLabel}</span>
          </div>
          <div class="tb-prod-actions">
            <a class="tb-btn-view" href="${escapeAttr(p.url)}" target="_top">View</a>
            ${numericVariantId && p.in_stock
              ? `<button type="button" class="tb-btn-cart" data-variant="${escapeAttr(numericVariantId)}">Add to Cart</button>`
              : `<button type="button" class="tb-btn-cart" disabled>Unavailable</button>`}
          </div>
        </div>
      `;

      const viewLink = card.querySelector(".tb-btn-view");
      if (viewLink) viewLink.addEventListener("click", function () { if (!p.sample) sendEvent("view", turnId, p.handle); });
      const cartBtn = card.querySelector(".tb-btn-cart:not([disabled])");
      if (cartBtn) {
        cartBtn.addEventListener("click", async function () {
          this.disabled = true;
          this.textContent = "Adding…";
          const added = p.sample ? true : await addToCart(this.dataset.variant, 1);
          if (added) {
            this.textContent = "Added to cart";
            if (!p.sample) sendEvent("add_to_cart", turnId, p.handle);
            this.style.background = "#10b981";
            if (!p.sample) { document.dispatchEvent(new CustomEvent("cart:refresh")); updateCartCount(); }
          } else {
            this.textContent = "Failed";
            this.disabled = false;
          }
        });
      }
      container.appendChild(card);
    });
    return container;
  }

  // ─── SHOPIFY CART API ────────────────────────────────────────────────────
  async function addToCart(variantId, quantity) {
    try {
      const res = await fetch("/cart/add.js", {
        method: "POST", headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: variantId, quantity }),
      });
      if (!res.ok) return false;
      const data = await res.json();
      return !!data.id;
    } catch (_) { return false; }
  }

  async function updateCartCount() {
    try {
      const data = await (await fetch("/cart.js")).json();
      const count = data.item_count || 0;
      document.querySelectorAll(
        ".cart-count, .cart__count, [data-cart-count], .header__cart-count, .js-cart-count, #CartCount, .cart-count-bubble span"
      ).forEach((el) => { el.textContent = count; });
    } catch (_) {}
  }

  // ─── THEME-EDITOR SAMPLE CONVERSATION ────────────────────────────────────
  function sampleImage(a, b, glyph) {
    const svg = '<svg xmlns="http://www.w3.org/2000/svg" width="180" height="220" viewBox="0 0 180 220">' +
      '<defs><linearGradient id="g" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="' + a + '"/><stop offset="1" stop-color="' + b + '"/></linearGradient></defs>' +
      '<rect width="180" height="220" fill="url(#g)"/></svg>';
    return "data:image/svg+xml;charset=utf-8," + encodeURIComponent(svg);
  }

  function renderSample() {
    const m = $("tb-messages");
    if (!m) return;
    Array.from(m.children).forEach((el) => { if (el.id !== "tb-typing") el.remove(); });
    const c = CFG.colors;
    const prods = [
      { title: "Sample product one", brand: "TrendBuy", min_price: 1899, max_price: 1899, in_stock: true, low_stock: false,
        url: "#", sample: true, variants: [{ id: "1", available: true }], image_url: sampleImage(c.c1, c.c2, "") },
      { title: "Sample product two", brand: "TrendBuy", min_price: 799, max_price: 1099, in_stock: true, low_stock: true,
        url: "#", sample: true, variants: [{ id: "2", available: true }], image_url: sampleImage(c.c2, c.c3, "") },
    ];
    restoring = true;
    appendMessage("bot", formatBotText(CFG.welcome), []);
    appendMessage("user", escapeHtml("Show me sarees for a wedding"), []);
    appendMessage("bot", formatBotText("Sample preview: this is how product suggestions will look."), prods);
    restoring = false;
    renderSuggestions();
  }

  // ─── TEXT HELPERS ────────────────────────────────────────────────────────
  function escapeHtml(str) {
    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
  }
  function escapeAttr(str) { return String(str).replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&#39;"); }

  function formatBotText(text) {
    // plain, professional look: drop any emoji / pictographs the model may add
    text = String(text).replace(/[\p{Extended_Pictographic}\uFE0F\u200D]/gu, "").replace(/ {2,}/g, " ");
    let html = escapeHtml(text);
    html = html.replace(/\*\*(.+?)\*\*/g, "<strong>$1</strong>");
    html = html.replace(/(\/products\/[a-z0-9\-]+)/g, '<a class="tb-link" href="$1" target="_top">$1</a>');
    return html.replace(/\n/g, "<br>");
  }

  // ─── RE-CONFIGURE (theme editor) ─────────────────────────────────────────
  let reconfTimer = null;
  function reconfigure() {
    clearTimeout(reconfTimer);
    reconfTimer = setTimeout(() => {
      readConfig();
      if (DESIGN_MODE) userPos = null;
      if (DESIGN_MODE && !$("tb-agent-root") && hadConfigBlock) {   // the editor re-rendered the section and removed our window
        built = false; init();
        if (CFG.editorSample) openPanel(true);
        return;
      }
      const root = $("tb-agent-root");
      if (!root) return;
      if (!hadConfigBlock && DESIGN_MODE) { root.style.display = "none"; return; }   // section switched off
      root.style.display = "";
      applyConfig();
      if (DESIGN_MODE && CFG.editorSample) {
        renderSample();
      } else if (DESIGN_MODE) {
        renderSuggestions();
      }
    }, 60);
  }

  window.__tbAgent = { reconfigure: reconfigure, open: () => openPanel(), close: closePanel };

  document.addEventListener("shopify:section:load", (e) => {
    if (e.target && e.target.querySelector && (e.target.querySelector("#tb-agent-config") || /trendbuy-agent/.test(e.target.id || ""))) reconfigure();
  });
  document.addEventListener("shopify:section:select", (e) => {
    if (e.target && /trendbuy-agent/.test(e.target.id || "") && built) { reconfigure(); if (CFG.editorSample) openPanel(true); }
  });
  document.addEventListener("shopify:section:deselect", (e) => {
    if (e.target && /trendbuy-agent/.test(e.target.id || "") && built) closePanel();
  });

  // ─── BOOT ────────────────────────────────────────────────────────────────
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
